module.exports = __webpack_public_path__ + "img/corner_morterboard.04aaba0a.svg";